import { getLandingPagePath } from '@/utils/landingPage';

export default ({ redirect, store }) => {
  // If current user has paid his/her subscription, don't let them see the component using this middleware
  const allowedStatuses = ['paying', 'trial'];

  if (allowedStatuses.includes(store.state.current_user._company.status)) {
    redirect(getLandingPagePath());
  }
};
